module.exports = __webpack_public_path__ + "static/media/video.1332df6d.webm";